export default {
     "inc-speed-support":{
          "categoryIcon":["ENSIGN"]
     },
     "fill_hp":{
          "categoryIcon":["POTION"]
     },
     "inc_dps":{
          "categoryIcon":["ENSIGN"]
     },
     "cure_freeze":{
          "categoryIcon":["ALL"]
     },
     "cure_poison":{
          "categoryIcon":["ALL"]
     },
     "cure_sheep":{
          "categoryIcon":["ALL"]
     },
     "cure_fire":{
          "categoryIcon":["ALL"]
     },
     "damage_enemy":{
          "categoryIcon":[
               "SWORD",
               "SPEAR",
               "GLOVE",
               "SHORT_WEAPON",
               "TWICE"
          ]
     },
     "auto_tap":{
          "categoryIcon":["SCROLL"]
     },
     "holding_tap":{
          "categoryIcon":["SCROLL"]
     },
     "fill_mana":{
          "categoryIcon":["POTION"]
     },
     "inc_mana":{
          "categoryIcon":["LANTERN"]
     },
     "inc_mana_refill_speed":{
          "categoryIcon":["LANTERN"]
     },
     "freeze-enemy":{
          "categoryIcon":[
               "SCROLL"
          ]
     },
     "poison-enemy":{
          "categoryIcon":[
               "SCROLL"
          ]
     },
     "sheep-enemy":{
          "categoryIcon":[
               "SCROLL"
          ]
     },
     "inc_bag_slot":{
          "categoryIcon":["POTION"]
     },
     "inc_critical_hit_ratio":{
          "categoryIcon":[
               "RING"
          ]
     },
     "inc_gold_enemy_drop":{
          "categoryIcon":["LANTERN"]
     },
     "inc_hp":{
          "categoryIcon":[
               "SHIELD",
               "SHIELD2D"
          ]
     },
     "inc_pet_active_time":{
          "categoryIcon":["ENSIGN"]
     },
     "inc_powerup_capacity":{
          "categoryIcon":[
               "ENSIGN",
               "LANTERN"
          ]
     },
     "inc_size_hero":{
          "categoryIcon":["ALL"]
     },
     "inc-gold-drop":{
          "categoryIcon":[
               "LANTERN",
               "RING",
               "ENSIGN"
          ]
     },
     "revive_hero":{
          "categoryIcon":["POTION"]
     },
     "revive_support":{
          "categoryIcon":["POTION"]
     },
}